module.exports = __webpack_public_path__ + "static/media/marker.d175f417.svg";